export default class HeaderState {
}